import React, { useState } from "react";
import axios from "axios";
import moment from "moment-jalaali";
import "./style.css";
import { useEffect } from "react";
import { AiOutlineEye, AiOutlineEyeInvisible } from "react-icons/ai";

function EditPersonalInfoModal({ closeModal, selectedUser }) {
  const [firstName, setFirstName] = useState(selectedUser.firstname);
  const [lastName, setLastName] = useState(selectedUser.lastname);
  const [mobileNumber, setMobileNumber] = useState(selectedUser.phonenumber);
  const [homeNumber, setHomeNumber] = useState(selectedUser.homenumber);
  const [userName, setUserName] = useState(selectedUser.username);
  const [nationalId, setNationalId] = useState(selectedUser.nationalid);
  const [passWord, setPassWord] = useState(selectedUser.password);
  const [passWordCheck, setPassWordCheck] = useState(selectedUser.password);
  const [showPassword, setShowPassword] = useState(false);
  const [showPasswordCheck, setShowPasswordCheck] = useState(false);
  const [userAccess, setUserAccess] = useState(selectedUser.access);
  const [birthDay, setBirthDay] = useState(
    moment(selectedUser.birthdate, "YYYY-M-D HH:mm:ss").format("jD")
  );
  const [birthMonth, setBirthMonth] = useState(
    moment(selectedUser.birthdate, "YYYY-M-D HH:mm:ss").format("jM")
  );
  const [birthYear, setBirthYear] = useState(
    moment(selectedUser.birthdate, "YYYY-M-D HH:mm:ss").format("jYYYY")
  );
  const [addUserError, setAddUserError] = useState(false);
  const [messageError, setMessageError] = useState("");

  const submitEditUser = async () => {
    var birthDate =
      birthYear.toString() +
      "/" +
      birthMonth.toString() +
      "/" +
      birthDay.toString() +
      " 00:00:00";
    if (
      firstName == "" ||
      lastName == "" ||
      userName == "" ||
      passWord == "" ||
      passWordCheck == "" ||
      mobileNumber == "" ||
      birthDay == 0 ||
      birthMonth == 0 ||
      birthYear == 0
    ) {
      setAddUserError(true);
      setMessageError("لطفا تمامی مقادیر الزامی را وارد کنید");
      return;
    } else {
      setAddUserError(false);
    }

    if (passWord != passWordCheck) {
      setAddUserError(true);
      setMessageError("لطفا برابری مقادیر رمز عبور را چک کنید");
      return;
    } else {
      setAddUserError(false);
    }

    const result = await axios.post(
      "https://request.kidiar.com/user/edit",
      {
        editId: selectedUser.id,
        firstname: firstName,
        lastname: lastName,
        useraccess: userAccess,
        mobilenumber: mobileNumber,
        homenumber: homeNumber,
        username: userName,
        password: passWord,
        nationalid: nationalId,
        birthdate: birthDate,
      },
      {
        headers: { "x-access-token": localStorage.getItem("token") },
      }
    );
    if (result.data.status == 1) {
      closeModal(false);
    } else {
      setAddUserError(true);
      setMessageError(result.data.message);
    }
  };

  return (
    <div className="modal-background">
      <div className="modal-container">
        <div className="modal-title">User Information</div>
        <div className="users-modal-title mode-text-7">
          You can check and edit your informations here
        </div>
        <div>
          <div className="d-flex mb-2 mode-text-9 font-15 ">Personal:</div>
          <div className="d-flex mb-2">
            <div className="d-flex w-50">
              <input
                type="text"
                placeholder="First Name"
                value={firstName}
                className="users-input w-100"
                onChange={(e) => setFirstName(e.target.value)}
              ></input>
            </div>
            <div className="d-flex w-50">
              <input
                type="text"
                placeholder="Last Name"
                value={lastName}
                className="users-input w-100"
                onChange={(e) => setLastName(e.target.value)}
              ></input>
            </div>
          </div>
          <div className="d-flex mb-2">
            <div className="d-flex w-50">
              <input
                type="number"
                placeholder="Mobile Number"
                value={mobileNumber}
                className="users-input w-100"
                onChange={(e) => setMobileNumber(e.target.value)}
              ></input>
            </div>
            <div className="d-flex w-50">
              <input
                type="number"
                placeholder="Home Number"
                value={homeNumber}
                className="users-input w-100"
                onChange={(e) => setHomeNumber(e.target.value)}
              ></input>
            </div>
          </div>
          <div className="d-flex mb-4">
            <div className="d-flex w-50">
              <input
                type="number"
                placeholder="National Id"
                value={nationalId}
                className="users-input w-100"
                onChange={(e) => setNationalId(e.target.value)}
              ></input>
            </div>
            <div className="d-flex w-50">
              <select
                className="users-input w-35"
                value={birthDay}
                onChange={(e) => setBirthDay(e.target.value)}
              >
                <option value={0}>Day</option>
                <option value={1}>1</option>
                <option value={2}>2</option>
                <option value={3}>3</option>
                <option value={4}>4</option>
                <option value={5}>5</option>
                <option value={6}>6</option>
                <option value={7}>7</option>
                <option value={8}>8</option>
                <option value={9}>9</option>
                <option value={10}>10</option>
                <option value={11}>11</option>
                <option value={12}>12</option>
                <option value={13}>13</option>
                <option value={14}>14</option>
                <option value={15}>15</option>
                <option value={16}>16</option>
                <option value={17}>17</option>
                <option value={18}>18</option>
                <option value={19}>19</option>
                <option value={20}>20</option>
                <option value={21}>21</option>
                <option value={22}>22</option>
                <option value={23}>23</option>
                <option value={24}>24</option>
                <option value={25}>25</option>
                <option value={26}>26</option>
                <option value={27}>27</option>
                <option value={28}>28</option>
                <option value={29}>29</option>
                <option value={30}>30</option>
              </select>
              <select
                className="users-input w-35"
                value={birthMonth}
                onChange={(e) => setBirthMonth(e.target.value)}
              >
                <option value={0}>Month</option>
                <option value={1}>January</option>
                <option value={2}>February</option>
                <option value={3}>March</option>
                <option value={4}>April</option>
                <option value={5}>May</option>
                <option value={6}>June</option>
                <option value={7}>July</option>
                <option value={8}>August</option>
                <option value={9}>September</option>
                <option value={10}>October</option>
                <option value={11}>November</option>
                <option value={12}>December</option>
              </select>
              <select
                className="users-input w-35"
                value={birthYear}
                onChange={(e) => setBirthYear(e.target.value)}
              >
                <option value={0}>Year</option>
                <option value={2023}>2023</option>
                <option value={2022}>2022</option>
                <option value={2021}>2021</option>
                <option value={2020}>2020</option>
                <option value={2019}>2019</option>
                <option value={2018}>2018</option>
                <option value={2017}>2017</option>
                <option value={2016}>2016</option>
                <option value={2015}>2015</option>
                <option value={2014}>2014</option>
                <option value={2013}>2013</option>
                <option value={2012}>2012</option>
                <option value={2011}>2011</option>
                <option value={2010}>2010</option>
                <option value={2009}>2009</option>
                <option value={2008}>2008</option>
                <option value={2007}>2007</option>
                <option value={2006}>2006</option>
                <option value={2005}>2005</option>
                <option value={2004}>2004</option>
                <option value={2003}>2003</option>
                <option value={2002}>2002</option>
                <option value={2001}>2001</option>
                <option value={2000}>2000</option>
                <option value={1999}>1999</option>
                <option value={1998}>1998</option>
                <option value={1997}>1997</option>
                <option value={1996}>1996</option>
                <option value={1995}>1995</option>
                <option value={1994}>1994</option>
                <option value={1993}>1993</option>
                <option value={1992}>1992</option>
                <option value={1991}>1991</option>
                <option value={1990}>1990</option>
                <option value={1989}>1989</option>
                <option value={1988}>1988</option>
                <option value={1987}>1987</option>
                <option value={1986}>1986</option>
                <option value={1985}>1985</option>
                <option value={1984}>1984</option>
                <option value={1983}>1983</option>
                <option value={1982}>1982</option>
                <option value={1981}>1981</option>
                <option value={1980}>1980</option>
                <option value={1979}>1979</option>
                <option value={1978}>1978</option>
                <option value={1977}>1977</option>
                <option value={1976}>1976</option>
              </select>
            </div>
          </div>
          <div className="d-flex mb-2 mode-text-9 font-15 ">Account:</div>
          <div className="d-flex mb-2">
            <div className="d-flex w-50">
              <input
                type="text"
                placeholder="Username"
                value={userName}
                className="users-input w-100 d-ltr"
                onChange={(e) => setUserName(e.target.value)}
              ></input>
            </div>
          </div>
          <div className="d-flex mb-2">
            <div
              className="d-flex w-100 align-items-center"
              style={{ position: "relative" }}
            >
              <input
                type={showPassword ? "text" : "password"}
                placeholder="Password"
                value={passWord}
                className="users-input w-100 d-ltr"
                onChange={(e) => setPassWord(e.target.value)}
              ></input>
              <a
                style={{
                  position: "absolute",
                  right: 0,
                  marginRight: "12px",
                  color: "#808080",
                  fontSize: "20px",
                }}
                onClick={() => setShowPassword(!showPassword)}
              >
                {showPassword ? (
                  <AiOutlineEyeInvisible></AiOutlineEyeInvisible>
                ) : (
                  <AiOutlineEye></AiOutlineEye>
                )}
              </a>
            </div>
          </div>
          <div className="d-flex mb-2">
            <div
              className="d-flex w-100 align-items-center"
              style={{ position: "relative" }}
            >
              <input
                type={showPasswordCheck ? "text" : "password"}
                placeholder="Password check"
                value={passWordCheck}
                className="users-input w-100 d-ltr"
                onChange={(e) => setPassWordCheck(e.target.value)}
              ></input>
              <a
                style={{
                  position: "absolute",
                  right: 0,
                  marginRight: "12px",
                  color: "#808080",
                  fontSize: "20px",
                }}
                onClick={() => setShowPasswordCheck(!showPasswordCheck)}
              >
                {showPasswordCheck ? (
                  <AiOutlineEyeInvisible></AiOutlineEyeInvisible>
                ) : (
                  <AiOutlineEye></AiOutlineEye>
                )}
              </a>
            </div>
          </div>
        </div>
        <div className="modal-footer mode-bg-8">
          <button onClick={() => closeModal(false)}>Cancel</button>
          <button onClick={submitEditUser}>Ok</button>
        </div>
        <div className="error-text">
          {addUserError && <p>{messageError}</p>}
        </div>
      </div>
    </div>
  );
}

export default EditPersonalInfoModal;
